import { useTranslation } from "react-i18next";
import ServiceDeviceDetails from "../components/ServiceDeviceDetails";
import LastServicesList from "../components/LastServicesList";
import ServiceDeviceSelector from "../components/ServiceDeviceSelector";
import { useDeviceServiceData } from "../ServiceHooks/useDeviceServiceData";
import { show } from "redux-modal";
import { useDispatch } from "react-redux";

const CreateServiceFormStepOne = ({ values, form, update, props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    options,
    selectedDevice,
    setSelectedDevice,
    lastServices,
    serviceBaseSelect,
    getDevices,
    fetchLastServices,
  } = useDeviceServiceData(values, form);

  return (
    <div>
      <ServiceDeviceSelector
        t={t}
        values={values}
        form={form}
        options={options}
        serviceBaseSelect={serviceBaseSelect}
        getDevices={getDevices}
        setSelectedDevice={setSelectedDevice}
        fetchLastServices={fetchLastServices}
        update={update}
        props={props}
      />

      <div className="step-one-wrapper">
        <div className="col-left">
          <ServiceDeviceDetails device={selectedDevice} />
          <div className="push-to-bottom">
            <div
              className="script__btn"
              style={{ cursor: "pointer" }}
              onClick={() =>
                dispatch(
                  show("ServiceCheckListModal", {
                    header: t("global:service.checkListModal"),
                  }),
                )
              }
            >
              {t("global:service.scriptTranslation")}
            </div>
          </div>
        </div>

        <div className="col-right">
          <LastServicesList
            services={lastServices}
            deviceUuid={selectedDevice?.uuid}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateServiceFormStepOne;
